import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class CancelledChequesReportService {
  constructor(private http: HttpUtilService) {}

  CancelledChequesReport(model: {
    FromDate: string;
    ToDate: string;
    ModelBank: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/CancelledChequesReport`,
      {
        model: model,
      },
    );
  }
}
